export const CHAPTER_ACTIONS = {
  SET_STATE: 'chapter/setState',
  GET_CHAPTERS: 'chapter/getChapters',
  GET_CHAPTER_BY_ID: 'chapter/getChapterById',
  DESTROY: "chapter/destroy"
};
